import React from 'react';
import { useHistory } from 'react-router-dom';

function ManageMHeader({ formExpand, goBack }) {
  const history = useHistory();
  return (
    <>
      <span className="dd-back-btn" onClick={goBack || history.goBack}>
        <span className="appkiticon icon-left-chevron-fill a-font-12" /> Back
      </span>

      {!formExpand && <div className="page-title">Manage Value Drivers</div>}
    </>
  );
}

export default React.memo(ManageMHeader);
